module.exports = __webpack_public_path__ + "img/login-img1.c9cb447e.png";